import React, { useState } from 'react';
import ImageModal from './ImageModal';

/**
 * MessageImages Component
 * Displays message images with thumbnail grid and modal view
 */
const MessageImages = ({ images, style = {} }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (!images || images.length === 0) return null;

  // Extract image URLs from Photo_datas objects or use directly if strings
  const imageUrls = images.map(img => {
    if (typeof img === 'string') {
      // Accept base64 data URLs or normal URLs; ignore raw ObjectId strings
      if (img.startsWith('data:image') || img.startsWith('http://') || img.startsWith('https://') || img.startsWith('/')) {
        return img;
      }
      return null;
    } else if (img && img.photodatas) {
      return img.photodatas; // Photo_datas object
    } else if (img && typeof img === 'object' && img._id) {
      // If it's a populated Photo_datas object, try to get photodatas
      return img.photodatas || null;
    }
    return null;
  }).filter(url => url !== null);

  if (imageUrls.length === 0) return null;

  const handleImageClick = (index) => {
    setSelectedIndex(index);
    setShowModal(true);
  };

  return (
    <>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: imageUrls.length === 1 ? '1fr' : 'repeat(auto-fit, minmax(100px, 1fr))',
          gap: '8px',
          marginTop: '10px',
          ...style
        }}
      >
        {imageUrls.map((imageUrl, index) => (
          <div
            key={index}
            style={{
              width: 'auto',
              maxHeight: style.maxHeight || '200px',
              overflow: 'hidden',
              // borderRadius: '8px',
              // border: '1px solid #ddd',
              // backgroundColor: '#f5f5f5',
              display: 'flex',
              justifyContent: 'left',
              alignItems: 'left',
              cursor: 'pointer',
              transition: 'transform 0.2s',
            }}
            onClick={() => handleImageClick(index)}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.01)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <img
              src={imageUrl}
              alt={`Message image ${index + 1}`}
              style={{
                width: 'auto',
                height: 'auto',
                maxHeight: style.maxHeight || '200px',
                maxWidth: '90%',
                objectFit: 'contain',
                display: 'block',
                marginLeft: '5px',
              }}
              loading="lazy"
            />
          </div>
        ))}
      </div>
      {showModal && (
        <ImageModal
          images={imageUrls}
          currentIndex={selectedIndex}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default MessageImages;
